import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import FaqTable from "./faqTable"

const FaqList = ({ user_type }) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={
              <>
                FAQ<small>s</small>
              </>
            }
          />
          <FaqTable user_type={user_type} />
        </Container>
      </div>
    </>
  )
}

export default FaqList
